import React, { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';
import './OrganisationsPage.css';

const OrganisationsPage = () => {
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrgs();
  }, []);

  const fetchOrgs = async () => {
    try {
      const response = await apiClient.get('/api/organisationer');
      setOrgs(response.data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="table-card">
        {loading ? <p>Henter data...</p> : (
          <table className="org-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Navn</th>
                <th>Handling</th>
              </tr>
            </thead>
            <tbody>
              {orgs.map(org => (
                <tr key={org.id}>
                  <td>{org.id}</td>
                  <td><strong>{org.navn}</strong></td>
                  <td>
                    <button style={{background:'none', border:'1px solid #ddd', padding:'5px 10px', borderRadius:'4px', cursor:'pointer'}}>
                      Rediger
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default OrganisationsPage;